import React, { DetailedHTMLProps, TextareaHTMLAttributes } from 'react'
import * as S from './styled'

interface Props extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
    editing: boolean
}

const DescriptionArea: React.FC<Props> = ({ editing, ...props }) => {
    return (
        <S.Container>
            {!editing ? (
                props.value
            ) : (
                <textarea {...props} />
            )}
        </S.Container>
    )
}

export default DescriptionArea
